module.exports = __webpack_public_path__ + "static/woyw-6-dfba1a4757fac945a19fc42adfddc9c3.jpg";